var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNigeriaflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_31626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    transform: "translate(0.266602 0.785156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.365 24.9819C19.0467 24.9819 24.4633 19.5652 24.4633 12.8835C24.4633 6.20177 19.0467 0.785156 12.365 0.785156C5.68322 0.785156 0.266602 6.20177 0.266602 12.8835C0.266602 19.5652 5.68322 24.9819 12.365 24.9819Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.266602 12.8829C0.266602 18.0848 3.54979 22.5193 8.15685 24.2288V1.53711C3.54979 3.24647 0.266602 7.68109 0.266602 12.8829Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4632 12.8829C24.4632 7.68109 21.1801 3.24647 16.573 1.53711V24.2288C21.1801 22.5193 24.4632 18.0848 24.4632 12.8829Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_31626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    fill: "white",
    transform: "translate(0.266602 0.785156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaflag);
export default __webpack_public_path__ + "static/media/Nigeriaflag.4656a4902c1bfed1e03110f6935c9efc.svg";
export { ForwardRef as ReactComponent };